module.exports = __webpack_public_path__ + "img/27_64.1308c899.png";